import React from 'react'

export default function Footer() {
    return (
      <div className="bg-black py-2 flex items-center justify-evenly">
        <div className="text-white font-bold">
          Made with <span className='text-red-300 '>❤</span> by Sanidhya
        </div>
      </div>
    );
}
